'use client';

import { CSSVariablesResolver, createTheme, mergeThemeOverrides } from '@mantine/core';

import { optiroTheme } from '../theme';

// Fonts are self-hosted by the app (next/font) and exposed as --font-sora / --font-mono.
export const landingTheme = mergeThemeOverrides(
  optiroTheme,
  createTheme({
    fontFamily: 'var(--font-sora), Sora, sans-serif',
    fontFamilyMonospace: 'var(--font-mono), "JetBrains Mono", ui-monospace, monospace',
    headings: { fontFamily: 'var(--font-sora), Sora, sans-serif' },
  })
);

const lightTokens = {
  '--landing-bg': '#f8f5ef',
  '--landing-surface': '#ffffff',
  '--landing-band': '#152f1d',
  '--landing-brand': '#3c735b',
  '--landing-ink': '#2d5a4a',
  '--landing-text': '#212529',
  '--landing-text-muted': '#495057',
  '--landing-text-dimmed': '#5f676f',
  '--landing-border': '#e9ecef',
  '--landing-border-strong': '#ced4da',
  '--landing-on-band': '#f8f5ef',
  '--landing-on-band-muted': '#a3d4c1',
};

// Derived from the light tokens: forest scale lifted for contrast on near-black green.
const darkTokens: typeof lightTokens = {
  '--landing-bg': '#101a15',
  '--landing-surface': '#17241d',
  '--landing-band': '#0a120e',
  '--landing-brand': '#56b090',
  '--landing-ink': '#a3d4c1',
  '--landing-text': '#e9ecef',
  '--landing-text-muted': '#adb5bd',
  '--landing-text-dimmed': '#8d979f',
  '--landing-border': '#25352c',
  '--landing-border-strong': '#3a4f43',
  '--landing-on-band': '#e9ecef',
  '--landing-on-band-muted': '#7bc2a8',
};

export const landingCssVariablesResolver: CSSVariablesResolver = () => ({
  variables: {},
  light: lightTokens,
  dark: darkTokens,
});
